import { push } from 'react-router-redux';
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import moment from 'moment'
import shortid from 'shortid'
import Hashids from 'hashids';
import {CopyToClipboard} from 'react-copy-to-clipboard'

import UserDropdown from '../UserDropdown/UserDropdown.js'
import Button from '../Button/Button.js'

import { downloadText,
   uploadPATFile,
   setAutoSave,
   setDXFGeneratorOpen,
   undo,
   redo,
   pmSetCurrentPattern,
   newBlankPattern,
   newDrawingPattern,
   tryToGetTeamPatterns,
   tryToUpdatePattern,
   tryToCreateNewPattern,
   tryToSaveACopy,
   showTooltip,
   hideTooltip,
   unsetCurrentTeam,
   setTrayOpen,
   setTemplateModalOpen,
   toggleLights,
   setRecentPatterns,
   setFullScreen,
   setDisplayZoomControls,
   setDisplayGridLines,
   setDisplayColors,
   setDisplayErrors,
   setDisplayRulers,
   pmUpdateFromHybrid,
   alignText,
   collapseColumns,
   removeBlankLines,
   removeComments,
   showLockedFeatureModal,
   setScaleModalOpen,
   setRotateModalOpen,
   setDownloadModalOpen,
   setImageExportModalOpen,
   setLoginModalOpen
} from '../../actions/actions.export.js'

import './ToolHeader.css';

import generateLockedTooltipText from '../../pattern_utilities/generateLockedTooltipText'
import canI from '../../canI.js';

var hashids = new Hashids('k100p');

var copyTimeout;

class ToolHeader extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      copied: false
    }


    this.handleDownloadPAT = this.handleDownloadPAT.bind(this);
    this.handleDecimalAdjust = this.handleDecimalAdjust.bind(this);
    this.handleConvert = this.handleConvert.bind(this);
  }

  handleDownloadPAT(){
    const { dispatch, patternManager, user, team } = this.props;
    dispatch(setDownloadModalOpen(true));
   
  }

  // handleImportClick(){
  //   document.getElementById('input-pattern').click();
  // }


  handleDecimalAdjust(amount){
    const { dispatch, patternManager } = this.props; 
    var pat = patternManager.cache[patternManager.current_pattern];
    if(pat.decimal_places === undefined) pat.decimal_places = 8;
    pat.decimal_places += amount;

    if(pat.decimal_places < 0){
      pat.decimal_places = 0;
    }
    if(pat.decimal_places > 10){
      pat.decimal_places = 10;
    }

    dispatch(pmUpdateFromHybrid({
      pattern: pat,
      cacheID: patternManager.current_pattern,
      regenText: true
    }))
  }


  handleConvert(factor, units){
    const { dispatch, patternManager } = this.props; 
    var pat = patternManager.cache[patternManager.current_pattern];
    
    for(var r in pat.rows){
      for(var c = 1; c < pat.rows[r].cells.length; c++){
        pat.rows[r].cells[c] *= factor;
      }
    }

    pat.units = units;

    dispatch(pmUpdateFromHybrid({
      pattern: pat,
      cacheID: patternManager.current_pattern,
      regenText: true
    }))
  }

  render(){
    const { patternManager, dispatch, user, team, globalReducer } = this.props;
    const pattern = patternManager.cache[patternManager.current_pattern];
    const cacheID = patternManager.current_pattern;

    var owned_by_you = false;
    var owned_by_your_current_team = false;
    
    if(user.isLoggedIn){

      if(pattern.scope === team.current && team.current && team.cache[team.current]){
        owned_by_your_current_team = true;
        if(pattern.created_by === user.id){
          owned_by_you = true;
        }
        if(team.cache[team.current].myRole === 'admin'){
          owned_by_you = true;
        }
      }

      if(pattern.scope === user.id && !team.current){
        owned_by_you = true;
      }
    }

    var data = {
      text: pattern.text
    };
    var shareURL = window.location.origin + '/pat/#' + encodeURIComponent(window.btoa(JSON.stringify(data)));
    var copyPatText = pattern.text;


    const makeItem = options => {
      return <span
        onClick={(e)=> {
          if(canI(user, team, options.feature, team.current)){
            options.onClick();
          } else {
            dispatch(showLockedFeatureModal(options.feature));
          } 
        }}
        onMouseEnter={(e)=> { 
          if(options.tooltip){
            dispatch(showTooltip({
              e: e,
              position: 'right', 
              lag: 150,
              nobr: false,
              content: <div style={{maxWidth: 200}}>{options.tooltip} &nbsp;{!canI(user, team, options.feature, team.current) && <i className="fad text-award fa-award"/>}</div>
            }))  
          }
        }}
        onMouseLeave={(e)=>{ 
          if(options.tooltip){
            dispatch(hideTooltip()) 
          }
        }}
        className={ "dropdown-item dropdown-item-flex dropdown-item-link " + (!canI(user, team, options.feature, team.current) && "dropdown-item-link-locked") + (options.disabled ? " dropdown-item-link-disabled" : "")}
        >
          <span className="dropdown-item-icon">
          {
            options.check && <i className="far fa-check text-success fa-fw"/>
          }
          {
            options.icon && 
            <i className={"fal fa-" + options.icon + " fa-fw"}/>
          }
          </span>
          <span className="dropdown-item-label">
            {options.display}
          </span>

          {
            (options.tooltip && canI(user, team, options.feature, team.current)) &&
            <i className={"fal fa-question-circle translucent fa-fw"}/>
          }

          { 
            !canI(user, team, options.feature, team.current) && 
            <i className="fad text-award fa-award"/> 
          }
        </span>
    }

    const makeIcon = options => {
      return  <span className="list-item">
        <Button
          size="header-icon" 
          display={<span><i className={"fal fa-fw fa-" + options.icon}/></span>} 
          color={"transparent " + (!canI(user, team, options.feature, team.current) && "button-header-icon-locked")}
          onClick={(e)=>{
            if(canI(user, team, options.feature, team.current)){
              options.onClick();
            } else {
              dispatch(showLockedFeatureModal(options.feature));
            } 
          }}
          disabled={options.disabled}
          onMouseEnter={(e)=> { 
            if(options.tooltip){
              dispatch(showTooltip({
                e: e,
                position: 'bottom', 
                lag: 150,
                nobr: false,
                content: <span>{options.tooltip} &nbsp;{!canI(user, team, options.feature, team.current) && <i className="fad text-award fa-award"/>}</span>
              }))  
            }
          }}
          onMouseLeave={(e)=>{ 
            if(options.tooltip){
              dispatch(hideTooltip()) 
            }
          }}
          />
      </span>
    }

    return <div id="tool-header">
      <div className="header-group header-group-grow">
        <div className="tool-header-menu-and-icons">
          <div className="flex-split tool-header-menu">
            <div className="list-left">
              <span className="list-item">
                <Button 
                  size="header" 
                  display="File"
                  dropdownOnly={true}
                  dropdownIcon={<span/>}
                  dropdownDirection="left"
                  dropdown={[
                      makeItem({
                        display: "New blank pattern",
                        onClick: (e)=>{
                          dispatch(push('/new'));
                        }
                      })
                      ,
                      makeItem({
                        display: "New pattern from template...",
                        tooltip: "Templates make creating the perfect pattern as easy as adjusting a view variables.",
                        onClick: (e)=>{
                          dispatch(setTrayOpen({
                            tray: 'calculators',
                            open: true
                          }))
                        }
                      })
                      ,
                      makeItem({
                        display: "New pattern from drawing...",
                        tooltip: "Draw your pattern with our canvas tool right in your browser.",
                        onClick: (e)=>{
                          dispatch(push('/new/drawing'));
                        }
                      })
                      ,
                      makeItem({
                        display: "New pattern from .DXF file...",
                        tooltip: "Draw your pattern in AutoCAD and instantly convert it.",
                        feature: 'dxf_import',
                        onClick: (e)=>{
                          dispatch(push('/new/dxf'));
                        }
                      })
                      ,
                      <div className="dropdown-divider"></div>
                      ,
                      makeItem({
                        display: "Open saved pattern...",
                        icon: 'folder-open',
                        feature: 'save_public_patterns',
                        onClick: (e)=>{
                          dispatch(setTrayOpen({
                            tray: 'saved',
                            open: true
                          }))
                        }
                      })
                      ,
                      makeItem({
                        display: <span>
                          Import .PAT file...
                        </span>,
                        icon: 'file-upload',
                        feature: 'file_import',
                        onClick: (e)=>{
                          dispatch(push('/new/import'));
                        }
                      })
                      ,
                      <div className="dropdown-divider"></div>
                      ,
                      makeItem({
                        display: (owned_by_you || !pattern.scope) ? "Save" : ((team.current && team.cache[team.current]) ? (owned_by_your_current_team ? "Save a copy" : "Save a copy to " + team.cache[team.current].display_name) : "Save a copy to your account."),
                        icon: (owned_by_you || !pattern.scope) ? 'save' : 'save',
                        disabled: patternManager.tryingToCreateNewPattern,
                        feature: pattern.private ? 'save_private_patterns' : 'save_public_patterns',
                        onClick: (e)=>{
                          if(user.isLoggedIn && !owned_by_you){
                            return dispatch(tryToCreateNewPattern(pattern)) 
                          }
                          if(user.isLoggedIn && owned_by_you){
                            return dispatch(tryToUpdatePattern(pattern))
                          } 
                        }
                      })
                      ,
                      makeItem({
                        display: "Toggle autosave",
                        check: globalReducer.autoSave,
                        feature: pattern.private ? 'save_private_patterns' : 'save_public_patterns',
                        onClick: (e)=>{
                          dispatch(setAutoSave(!globalReducer.autoSave));
                        }
                      })
                      ,
                      makeItem({
                        display: "Make a copy",
                        feature: 'make_a_copy',
                        onClick: (e)=>{
                          dispatch(tryToSaveACopy(pattern));
                        }
                      })
                      ,
                      <div className="dropdown-divider"></div>
                      ,
                      makeItem({
                        display: "Download .PAT file",
                        icon: "file-download",
                        onClick: this.handleDownloadPAT
                      })
                      ,
                      makeItem({
                        display: "Export Image...",
                        feature: 'image_export',
                        icon: "camera",
                        onClick: (e) => {
                          dispatch(setImageExportModalOpen(true));
                        }
                      })
                    ]}
                  />
              </span>

              <span className="list-item">
                <Button 
                  size="header" 
                  display="Edit"
                  dropdownOnly={true}
                  dropdownIcon={<span/>}
                  dropdownDirection="left"
                  dropdown={[
                      makeItem({
                        display: "Undo",
                        icon: "undo-alt",
                        disabled: ( patternManager.history.memory.length === 0 || patternManager.history.undoIndex === patternManager.history.memory.length ),
                        onClick: (e)=>{
                          dispatch(undo({
                            cacheID: patternManager.current_pattern
                          })); 
                        }
                      })
                      ,
                      makeItem({
                        display: "Redo",
                        icon: "redo-alt",
                        disabled: (  patternManager.history.memory.length === 0 || patternManager.history.undoIndex <= 1 ),
                        onClick: (e)=>{
                          dispatch(redo({
                            cacheID: patternManager.current_pattern
                          })); 
                        }
                      })
                      ,
                      <div className="dropdown-divider"></div>
                      ,
                      makeItem({
                        display: "Bake pattern",
                        disabled: pattern.mode === 'raster',
                        tooltip: "Patterns created using a template or drawing can be baked to allow for manual editing of the raw .PAT file.",
                        onClick: (e)=>{
                          dispatch(pmUpdateFromHybrid({
                            cacheID: cacheID, 
                            pattern: {
                              mode: 'raster' 
                            }
                          })); 
                        }
                      })
                      ,
                      <div className="dropdown-divider"></div>
                      ,
                      pattern.mode !== 'raster' ?
                      <div className="dropdown-item dropdown-item-blank">
                        <small className="translucent text-700">BAKE TO ENABLE</small>
                      </div>
                      :
                      <div/>
                      ,
                      makeItem({
                        display: "Scale...",
                        feature: 'scale',
                        disabled: pattern.mode !== 'raster',
                        tooltip: "Transform all values in a baked pattern by a scale factor.",
                        onClick: (e) => {
                          dispatch(setScaleModalOpen(true)); 
                        }
                      })
                      ,
                      makeItem({
                        display: "Rotate...",
                        feature: 'rotate',
                        disabled: pattern.mode !== 'raster',
                        tooltip: "Rotate a baked patterns by a configured angle.",
                        onClick: (e) => {
                          dispatch(setRotateModalOpen(true)); 
                        }
                      })
                      ,
                      makeItem({
                        display: "Convert to inches",
                        disabled: pattern.units === 'INCH' || pattern.mode !== 'raster',
                        feature: 'convert',
                        tooltip: "Convert all values in a baked pattern to inches by dividing by 2.54",
                        onClick: (e) => {
                          this.handleConvert(1 / 25.4, 'INCH');
                        }
                      })
                      ,
                      makeItem({
                        display: "Convert to millimeters",
                        disabled: pattern.units === 'MM' || pattern.mode !== 'raster',
                        feature: 'convert',
                        tooltip: "Convert all values in a baked pattern to millimeters by multiplying by 2.54",
                        onClick: (e) => {
                          this.handleConvert(25.4, 'MM');
                        }
                      })
                    ]}
                  />
              </span>

              <span className="list-item">
                <Button 
                  size="header" 
                  display="View"
                  dropdownOnly={true}
                  dropdownIcon={<span/>}
                  dropdownDirection="left"
                  dropdown={[
                      makeItem({
                        display: "Show zoom controls",
                        check: globalReducer.zoomControls,
                        onClick: (e)=>{
                          dispatch(setDisplayZoomControls(!globalReducer.zoomControls))
                        }
                      })
                      ,
                      makeItem({
                        display: "Show grid lines",
                        check: globalReducer.gridLines,
                        onClick: (e)=>{
                          dispatch(setDisplayGridLines(!globalReducer.gridLines)) 
                        }
                      })
                      ,
                      makeItem({
                        display: "Show rulers",
                        check: globalReducer.rulers,
                        onClick: (e)=>{
                          dispatch(setDisplayRulers(!globalReducer.rulers))
                        }
                      })
                      ,
                      <div className="dropdown-divider"></div>
                      ,
                      makeItem({
                        display: "Highlight root lines",
                        check: globalReducer.colors,
                        onClick: (e)=>{
                          dispatch(setDisplayColors(!globalReducer.colors))
                        }
                      })
                      ,
                      makeItem({
                        display: "Highlight error lines",
                        check: globalReducer.errors,
                        onClick: (e)=>{
                          dispatch(setDisplayErrors(!globalReducer.errors))
                        }
                      })
                      ,
                      <div className="dropdown-divider"></div>
                      ,
                      makeItem({
                        display: "Full screen",
                        feature: 'full_screen',
                        onClick: (e)=>{
                          dispatch(setFullScreen(!globalReducer.fullScreen))
                        }
                      })
                      ,
                      <div className="dropdown-divider"></div>
                      ,
                      makeItem({
                        display: "Night mode",
                        feature: 'nightmode',
                        check: canI(user, team, 'nightmode', team.current) && !globalReducer.lights,
                        onClick: (e)=>{
                          dispatch(toggleLights(!globalReducer.lights))
                        }
                      })
                      ,
                      makeItem({
                        display: "Show recent patterns",
                        feature: 'recent_patterns',
                        check: canI(user, team, 'recent_patterns', team.current) && globalReducer.showRecentPatterns,
                        onClick: (e)=>{
                          dispatch(setRecentPatterns(!globalReducer.showRecentPatterns))
                        }
                      })
                    ]}
                  />
              </span>

              <span className="list-item">
                <Button 
                  size="header" 
                  display="Share"
                  dropdownOnly={true}
                  dropdownIcon={<span/>}
                  dropdownDirection="left"
                  dropdown={[
                      <CopyToClipboard key={1} text={window.location.href}>
                        {
                          makeItem({
                            icon: 'link',
                            disabled: patternManager.current_pattern === 'local',
                            onClick: (e) => { 
                              
                            },
                            display: "Copy sharable link to clipboard"
                          })
                        }
                      </CopyToClipboard>
                      ,
                      <CopyToClipboard key={2} text={shareURL}>
                        {
                          makeItem({
                            icon: 'ghost',
                            onClick: (e) => { 
                              
                            },
                            display: "Copy anonymous link to clipboard"
                          })
                        }
                      </CopyToClipboard>
                      ,
                      <CopyToClipboard key={3} text={canI(user, team, 'quick_copy_text', team.current) ? copyPatText : ""}>
                        {
                          makeItem({
                            icon: 'clipboard',
                            feature: 'quick_copy_text',
                            onClick: (e) => { 
                              
                            },
                            display: "Copy .PAT file text to clipboard"
                          })
                        }
                      </CopyToClipboard>
                    ]}
                  />
              </span>


              <span className="list-item">
                <Button 
                  size="header" 
                  display="Format"
                  dropdownOnly={true}
                  dropdownIcon={<span/>}
                  dropdownDirection="left"
                  dropdown={[
                      makeItem({
                        icon: 'align-left',
                        feature: 'text_editor_pro_tools',
                        onClick: (e) => { 
                          dispatch(collapseColumns({
                            pattern: {
                              text_alignment: "collapsed"
                            },
                            cacheID: patternManager.current_pattern,
                            regenText: true
                          }))
                        },
                        display: "Collapse .PAT columns"
                      })
                      ,
                      makeItem({
                        icon: 'align-justify',
                        feature: 'text_editor_pro_tools',
                        onClick: (e) => { 
                          dispatch(alignText({
                            pattern: {
                              text_alignment: "aligned"
                            },
                            cacheID: patternManager.current_pattern,
                            regenText: true
                          }))
                        },
                        display: "Align .PAT columns"
                      })
                      ,
                      makeItem({
                        icon: 'comment-times',
                        feature: 'text_editor_pro_tools',
                        onClick: (e) => { 
                          dispatch(removeComments())
                        },
                        display: "Remove .PAT comments"
                      })
                      ,
                      makeItem({
                        feature: 'text_editor_pro_tools',
                        onClick: (e) => { 
                          dispatch(removeBlankLines())
                        },
                        display: "Remove .PAT blank lines"
                      })
                      ,
                      <div className="dropdown-divider"></div>
                      ,
                      makeItem({
                        icon: 'sort-size-up',
                        disabled: pattern.mode === 'raster',
                        feature: 'decimal_precision',
                        onClick: (e) => { 
                          this.handleDecimalAdjust(1)
                        },
                        display: "Increase decimal precision"
                      })
                      ,
                      makeItem({
                        icon: 'sort-size-down',
                        disabled: pattern.mode === 'raster',
                        feature: 'decimal_precision',
                        onClick: (e) => { 
                          this.handleDecimalAdjust(-1)
                        },
                        display: "Decrease decimal precision"
                      })
                    ]}
                  />
              </span>

              <span className="list-item">
                {
                  (owned_by_you) ? <small className="list-item text-muted">
                    {
                      ((globalReducer.autoSave && pattern.unsavedChanges) || (patternManager.tryingToUpdatePattern || patternManager.tryingToCreateNewPattern)) ?
                      <i key={shortid.generate()}><i className="far fa-spinner-third fa-spin fa-fw fa-lg"/>&nbsp;&nbsp;Saving changes...</i>
                      :
                      <span>
                        {
                          globalReducer.autoSave ?<i className="text-success text-700">Autosave is on. </i> : <i className="text-danger text-700"> Autosave is off. </i>
                        }
                        { 
                          pattern.unsavedChanges ? 
                          <i>Unsaved changes have been made.</i>
                          :
                          <span>
                            <i>Last saved at { moment(pattern.updated_on).format('h:mm a [on] MMM Do') } <i className="fa fa-check text-success"/></i> 
                          </span>
                        }
                      </span>
                    }
                  </small>
                  :
                  (owned_by_your_current_team) ? <small className="list-item text-muted">
                    <span>This pattern was created for <strong>{team.cache[team.current].display_name}</strong> by <strong>{pattern.created_by_name}</strong>, saving will create a new version with your edits.</span>
                  </small>
                  :
                  <small className="list-item text-muted">
                  {
                    user.isLoggedIn ?
                      (
                        patternManager.tryingToCreateNewPattern ?
                        <i key={shortid.generate()}><i className="far fa-spinner-third fa-spin fa-fw fa-lg"/>&nbsp;&nbsp;Saving new pattern...</i>
                        :
                        (pattern.scope === undefined) ?
                        <i>This pattern hasn't been saved yet.</i>
                        :
                        pattern.rows.length === 0 ?
                        <i></i>
                        :
                        (
                          user.roles.enterprise ? 
                          <i className="text-danger">This pattern is not saved to your workspace.</i>
                          :
                          <i className="text-danger">This pattern is not saved to your current workspace.</i>  
                        )
                        
                      )
                      :
                      <i className="text-primary">Sign up for a free account to save this pattern.</i> 
                  }
                  </small>
                }   
              </span>
            </div>
            <div className="list-right small-spacing">
            {
              user.isLoggedIn &&
              <Link to="/docs" target="_blank" className={"list-item header-link text-400 underlined d-none d-md-block"}>Docs & Tutorials</Link>
            }
            {
              user.isLoggedIn &&
              <UserDropdown/>
            }
            </div>
          </div>
          <div className="flex-split tool-header-icons">
            <div className="">
              {
                makeIcon({
                  icon: "undo-alt",
                  onClick: (e) =>{ 
                    dispatch(undo({
                      cacheID: patternManager.current_pattern
                    })); 
                  },
                  disabled: patternManager.history.memory.length === 0 || patternManager.history.undoIndex === patternManager.history.memory.length
                })
              }
              
              {
                makeIcon({
                  icon: "redo-alt",
                  onClick: (e) =>{ 
                    dispatch(redo({
                      cacheID: patternManager.current_pattern
                    })); 
                  },
                  disabled: patternManager.history.memory.length === 0 || patternManager.history.undoIndex <= 1
                })
              }
              
              <span className="list-item tool-header-icon-divider"/>


              {
                makeIcon({
                  icon: 'folder-open',
                  feature: 'save_public_patterns',
                  onClick: (e) => { 
                    dispatch(setTrayOpen({
                      tray: 'saved',
                      open: true
                    }))
                  },
                  tooltip: "Open Saved Pattern"
                })
              }


              {
                makeIcon({
                  icon: (owned_by_you || !pattern.scope) ? 'save' : 'save',
                  disabled: patternManager.tryingToCreateNewPattern,
                  feature: 'save_public_patterns',
                  onClick: (e) => { 
                    if(user.isLoggedIn && !owned_by_you){
                      return dispatch(tryToCreateNewPattern(pattern)) 
                    }
                    if(user.isLoggedIn && owned_by_you){
                      return dispatch(tryToUpdatePattern(pattern))
                    }
                  },
                  tooltip: (owned_by_you || !pattern.scope) ? "Save" : ((team.current && team.cache[team.current]) ? (owned_by_your_current_team ? "Save a copy" : "Save a copy to " + team.cache[team.current].display_name) : "Save a copy to your account."),
                  
                })
              }


              {
                makeIcon({
                  icon: 'file-upload',
                  feature: 'file_import',
                  onClick: (e) => { 
                    dispatch(push('/new/import'));
                  },
                  tooltip: "Import .PAT file"
                })
              }


              {
                makeIcon({
                  icon: 'file-download',
                  feature: 'file_export',
                  onClick: (e) => { 
                    this.handleDownloadPAT();
                  },
                  tooltip: "Download .PAT file"
                })
              }

              {
                makeIcon({
                  icon: "camera",
                  feature: 'image_export',
                  tooltip: "Export Image",
                  onClick: (e) => {
                    dispatch(setImageExportModalOpen(true));
                  }
                })
              }

              <span className="list-item tool-header-icon-divider"/>

              <span className="list-item">
                <CopyToClipboard key={8} text={window.location.href}>
                  {
                    makeIcon({
                      icon: 'link',
                      feature: 'save_public_patterns',
                      disabled: patternManager.current_pattern === 'local',
                      onClick: (e) => { },
                      tooltip: "Copy Sharable Link"
                    })
                  }
                </CopyToClipboard>
              </span>

              <span className="list-item">
                <CopyToClipboard key={8} text={shareURL}>
                  {
                    makeIcon({
                      icon: 'ghost',
                      onClick: (e) => { },
                      tooltip: "Copy Anonymous URL"
                    })
                  }
                </CopyToClipboard>
              </span>


              <span className="list-item">
                <CopyToClipboard key={8} text={canI(user, team, 'quick_copy_text', team.current) ? copyPatText : ""}>
                  {
                    makeIcon({
                      icon: 'clipboard',
                      feature: 'quick_copy_text',
                      onClick: (e) => { },
                      tooltip: "Copy .PAT Text"
                    })
                  }
                </CopyToClipboard>
              </span>

              <span className="list-item tool-header-icon-divider"/>

              {
                makeIcon({
                  icon: 'align-left',
                  feature: 'text_editor_pro_tools',
                  onClick: (e) => { 
                    dispatch(alignText({
                      pattern:  {
                        text_alignment: "collapsed"
                      },
                      cacheID: patternManager.current_pattern,
                      regenText: true
                    }))
                  },
                  tooltip: "Collapse .PAT columns"
                })
              }

              {
                makeIcon({
                  icon: 'align-justify',
                  feature: 'text_editor_pro_tools',
                  onClick: (e) => { 
                    dispatch(alignText({
                      pattern: {
                        text_alignment: "aligned"
                      },
                      cacheID: patternManager.current_pattern,
                      regenText: true
                    }))
                  },
                  tooltip: "Align .PAT columns"
                })
              }

              {
                makeIcon({
                  icon: 'comment-times',
                  feature: 'text_editor_pro_tools',
                  onClick: (e) => { 
                    dispatch(removeComments())
                  },
                  tooltip: "Remove .PAT comments"
                })
              }

              <span className="list-item tool-header-icon-divider"/>

              {
                makeIcon({
                  icon: 'sort-size-down',
                  feature: 'decimal_precision',
                  disabled: pattern.mode === 'raster',
                  onClick: (e) => { 
                    this.handleDecimalAdjust(-1)
                  },
                  tooltip: "Decrease decimal precision"
                })
              }

              {
                makeIcon({
                  icon: 'sort-size-up',
                  feature: 'decimal_precision',
                  disabled: pattern.mode === 'raster',
                  onClick: (e) => { 
                    this.handleDecimalAdjust(1)
                  },
                  tooltip: "Increase decimal precision"
                })
              }
            </div>
            <div className="list-right small-spacing">
              {
                (!team.current && user.trial_end && parseInt(user.trial_end) > new Date().getTime()) && <div className="list-item">
                  {
                    user.roles.pro ?
                    <Link to="/settings/my-account/billing" className="text-warning text-400"><i>Your free trial of Pattycake Pro ends {moment(parseInt(user.trial_end)).fromNow()}.</i></Link>
                    :
                    <Link to="/settings/my-account/upgrade-to-pro" className="text-warning text-400"><i>You can continue trying Pattycake Pro until {moment(parseInt(user.trial_end)).format('MMMM D')}.</i></Link>
                  }
                </div>
              }

              {
                (team.current && team.cache[team.current] && team.cache[team.current].overstaffed) && <div className="list-item">
                  {
                    team.cache[team.current].myRole === 'admin' ?
                    <Link to={"/settings/firm/" + hashids.encode(team.current) + '/members/access'} className="text-danger text-400"><i>Your firm is locked due to being overstaffed.</i></Link>
                    :
                    <span className="text-danger text-400"><i>Your firm is locked due to being overstaffed. Please contact your administrator.</i></span>
                  }
                </div>
              }


              {
                (team.current && team.cache[team.current] && team.cache[team.current].subscription_ended) && <div className="list-item">
                  {
                    team.cache[team.current].myRole === 'admin' ?
                    <Link to={"/settings/firm/" + hashids.encode(team.current) + '/billing'} className="text-danger text-400"><i>Your firm's subscription is no longer active.</i></Link>
                    :
                    <span className="text-danger text-400"><i>Your firm's subscription is no longer active. Please contact your administrator.</i></span>
                  }
                </div>
              }

              <div className="list-item translucent"></div>
              {
                user.isLoggedIn ?
                <div className="list-item">
                  {
                    user.roles.enterprise ? 
                    <span className="translucent">Workspace: </span> 
                    :
                    <span className="translucent">Current workspace: </span>   
                  }
                  
                  <strong>
                    {
                      (team.current && team.cache[team.current]) && <span style={{color: team.cache[team.current].theme}}>{team.cache[team.current].display_name}</span>
                    }
                    {
                      !team.current && (user.roles.pro ? "Your Pro account" : "Your personal account")
                    }
                  </strong>
                </div>
                :
                <div className="list-item translucent">

                </div>
              }
            </div>
          </div>

        </div>
      </div>
        
      {
        !user.isLoggedIn && 
        <div className="header-group header-group-padded list-right">
          <Link to="/at-work" className={"list-item header-link text-400 underlined d-none d-md-block"}>Pattycake at Work</Link>
          <Link to="/pricing" className={"list-item header-link text-400 underlined d-none d-md-block"}>Pricing</Link>
          <Link to="/docs" className={"list-item header-link text-400 underlined d-none d-md-block " + (window.location.pathname === '/docs' ? "header-link-current" : "")}>Docs</Link>
          <span onClick={(e)=>{ dispatch(setLoginModalOpen(true)); }} className="clickable list-item text-400 underlined header-link">Log In</span>
          <Link to="/sign-up" className={"list-item button-link d-none d-md-block"}><Button display="Sign Up for Free" color="grey" size="medium"/></Link>
        </div>
      }
    </div>
  }
}

const mapStateToProps = (state) => {
  const { 
    patternManager, user, team, globalReducer
    //...
  } = state;

  return {
    patternManager, user, team, globalReducer
    //...
  }
}

export default connect(mapStateToProps)(ToolHeader);


// WEBPACK FOOTER //
// ./src/components/ToolHeader/ToolHeader.js